import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { Input } from '../../../../../lib/web/components/input';

@Component({
    selector: '.a-toggle-selector'
})
export class ToggleSelectorComponent extends ComponentBase<HTMLElement> {

    @Input('mode')
    public _mode: 'single' | 'multiple' = null;

    public constructor(node: HTMLElement) {
        super(node);
    }

    public reset(raiseEvent: boolean = true): void {
        this.removeClass('u-button--primary', '.a-toggle-selector__item');
        this.addClass('u-button--secondary', '.a-toggle-selector__item');
        if (raiseEvent) {
            this.dispatchCustomEvent('selection-changed');
        }
    }

    @ClickListener('.a-toggle-selector__item')
    public onItemClicked(e: MouseEvent): void {
        const item: HTMLButtonElement = (e.target as HTMLElement).closest('.a-toggle-selector__item') as HTMLButtonElement;
        this.toggleItem(item);
    }

    private toggleItem(item: HTMLButtonElement): void {
        if (item) {
            if (this._mode === 'single') {
                this.reset(false);
            }
            this.toggleClasses(item.classList.contains('u-button--secondary'), 'u-button--primary', 'u-button--secondary', item);
            this.dispatchCustomEvent('selection-changed');
        }
    }

    public get selected(): number[] {
        return Array.from(this.node.querySelectorAll('.a-toggle-selector__item.u-button--primary')).map(n => parseInt((n as HTMLElement).dataset.id));
    }

    public set selected(value: number[]) {
        this.reset();
        (value || []).forEach(v => this.toggleItem(this._node.querySelector(`.a-toggle-selector__item[data-id='${v}']`)));
    }
}